import React from 'react';

import EditPromptForm from '../shared/EditPromptForm';

export default function EditWorkspacePrompt() {
  return <EditPromptForm targetClassname='Summarization' promptLabel='Workspace' backPath='/admin/workspace-prompts' />;
}
